import React, {useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header.jsx';           // ваш компонент шапки
import mixImg from '../images/DSC_7376.png'; // пример картинки
import '../style/CakeDetail.css';

const CakeDetailMix = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();

  return (
    <>
      <Header />

      <div className="detail-container">
        <div className="detail-text">
          <h2>Наполеон ассорти</h2>
          <p>Хороший выбор, чтобы попробовать все вкусы в дружной компании.</p>
          <p><strong>Вес:</strong> 1,4&nbsp;кг</p>
          <p><strong>Цена:</strong> 2500&nbsp;₽</p>
          <button onClick={() => navigate(-1)} className="back-button">
            ← Назад
          </button>
        </div>

        <div className="detail-image">
          <img src={mixImg} alt="Наполеон Классический" />
        </div>
      </div>
    </>
  );
};

export default CakeDetailMix;
